import cn from 'classnames';
import React from 'react';
import { Typography } from 'seagull';
import styles from "./TabPimple.module.scss";
export default function TabPimple(_ref) {
  let {
    count,
    className
  } = _ref;
  if (isNaN(count) || 0 >= count) return null;
  const content = count >= 9 ? '9+' : String(count);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, className)
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "invertedStandard",
    as: "span",
    className: styles.pimple,
    "aria-label": "".concat(content, " notifications"),
    "data-testid": "pimple"
  }, count >= 9 ? '9+' : String(count)));
}